import {
  CreateOrUpdateJobConfigurationDto,
  CreateOrUpdateJobConfigurationDtoTypeEnum,
  JobConfigurationDto,
} from '@/api/generator';

export function toCreateOrUpdateJobConfigurationDto(
  dto: JobConfigurationDto,
): CreateOrUpdateJobConfigurationDto {
  return {
    ...dto,
    assignedRoles: dto.assignedRoles?.map((role) => role.id),
    assignedUsers: dto.assignedUsers?.map((user) => user.id),
    reviewRoles: dto.reviewRoles?.map((role) => role.id),
    reviewUsers: dto.reviewUsers?.map((user) => user.id),
    targetSystemId: dto.targetSystem?.id,
    $type:
      CreateOrUpdateJobConfigurationDtoTypeEnum.PtwPtw100AppZeroApplicationSharedJobConfigurationComponentDtoCreateOrUpdateJobConfigurationDtoPtwPtw100AppZeroApplicationShared,
  };
}
